module.exports = __webpack_public_path__ + "img/8.35f932e2.svg";